
import { useState } from 'react';
import { Cookies } from 'react-cookie';
import { useEffect } from 'react';
import { API_SERVER } from '../../EnvConfig/env_config';
import {  setFocus, setTitle } from '../Common/Common';
import Loader from '../Layout/Loader';
import { post } from '../Common/service';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { getCommonData } from '../Common/CommanServices';
import { useNavigate } from "react-router-dom";

const cookies = new Cookies();
function ResetPassword({ open, setOpen }) {
    const [resetPasswordData, setResetPasswordData] = useState({ UserCode: '', NewPassword: '', ConfirmPassword: '' });
    const navigate = useNavigate();
    const [resetPasswordAutoComplete,setResetPasswordAutocomplete ] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [MenuText, setMenuText] = useState("Reset Password");
    const Token = cookies.get('token');
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const Source = 'web'

    const HandleChange = (prop, value) => {
        setResetPasswordData(resetPasswordData => ({ ...resetPasswordData, [prop]: value }))
    }

    const handleSubmit = () => {
        setIsLoading(true)
        const data = {
            ...resetPasswordData,
            Token: Token,
            LoginUserCode: String(LoginUserCode),
            Source: Source
        }
        post(`${API_SERVER}/api/User/ResetPassword`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);

                handleReset();
                setIsLoading(false);
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);

                setFocus(res.focus)
                setIsLoading(false)
            }
        })
    };

    const handleReset = () => {
        setResetPasswordData({ ...resetPasswordData, UserCode: '', NewPassword: '', ConfirmPassword: '' });
    }
    const getUser = () => {
        setResetPasswordAutocomplete([]);
        let temp = {
            Type: "GetUserCode",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };
        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let UserData = res.autoCompleteData || [];
                setResetPasswordAutocomplete(UserData);
            } else {
                setResetPasswordAutocomplete([]);
            }
        });
    };
    const UserOption = [];

    for (let i = 0; i < resetPasswordAutoComplete.length; i++) {
        UserOption.push(resetPasswordAutoComplete[i].values);
    };
   
    useEffect(() => {
        setTitle('ResetPassword', setOpen);
        setFocus('txtUserCode');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area ">
                                <div className="row">
                                    <div className="col-lg-4 col-md-6 col-sm-12" >
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtNewPassword") };
                                                }}
                                                label='User Code'
                                                placeholder="User Code"
                                                maxLength='50'
                                                options={UserOption}
                                                id='txtUserCode'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getUser()}
                                                inputValue={resetPasswordData.UserCode ? resetPasswordData.UserCode : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('UserCode', newInputValue)
                                                  
                                                }}
                                            />
                                        </div>
                                        <div className="fields">
                                            <label className="form-label">New Password <span className="Required">*</span></label>
                                            <input
                                                id='txtNewPassword'
                                                maxLength='15'
                                                minLength='8'
                                                type="password"
                                                placeholder='New Password'
                                                className="form-control"
                                                autoComplete="off"
                                                value={resetPasswordData.NewPassword}
                                                onChange={(e) => setResetPasswordData({ ...resetPasswordData, NewPassword: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtConfirmPassword')
                                                    };
                                                }}
                                            />
                                        </div>
                                        <div className="fields">
                                            <label className="form-label">Confirm Password <span className="Required">*</span></label>
                                            <input
                                                id='txtConfirmPassword'
                                                maxLength='15'
                                                minLength='8'
                                                type="password"
                                                className="form-control"
                                                placeholder='Confirm Password'
                                                autoComplete="off"
                                                name='oldPassword'
                                                value={resetPasswordData.ConfirmPassword}
                                                onChange={(e) => setResetPasswordData({ ...resetPasswordData, ConfirmPassword: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit(e)
                                                    };
                                                }}
                                            />
                                        </div>
                                        <div className="col-lg-12 mb-4">
                                            <div className="lms-new-button text-center">
                                                <button className="button save-btn" onClick={handleSubmit}>
                                                    <i className="bi bi-check-lg" /> Reset Password
                                                </button>
                                                <button className="button reset-btn" onClick={handleReset}>
                                                    <i className="bi bi-arrow-clockwise" />Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-8 col-md-8 col-sm-12'>
                                        <div className='password-policy-border'>
                                            <div className='w-100 py-2 password-policy px-3'>
                                                <h6 className="m-0 font-weight-bold text-white">{'Password Policy'}</h6>
                                            </div>
                                            <div className='p-4'>
                                                <div className="form-group px-2">
                                                    <li>White spaces are not allowed.</li>
                                                    <li>Password must be between 8 to 15 character(s).</li>
                                                    <li>Password must be combination of atleast one numeric and one upper case letter and Special character [@@$#!() ], white spaces are not allowed.</li>
                                                    <li>New password and confirm password must be same.</li>
                                                    <li>Old password and New password should be different.</li>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
           
        </main>
    );
}
export default ResetPassword;